import React, { useCallback, useState } from "react";
import { itemNameList, getItemFile } from "./utils/items";
import { zetsuboNameList, getZetsuboFile } from "./utils/theme";
import ItemCard from "./components/atoms/ItemCard";
import ZetsuboCard from "./components/atoms/ZetsuboCard";
import TextInput, { TextInputs } from "./components/atoms/TextInput";
import bgImage from "./image/frame.png";
import itemImage from "./image/items/I000.png";
import themeImage from "./image/themes/Z000.png";
import { Disclosure } from "@headlessui/react";
import Canvas from "./components/molecules/Canvas";
import "./App.css";

function App() {
	const [textName, setTextName] = useState<string>("");
	const [inputName, setInputName] = useState<string>("");
	const [textSolution, setTextSolution] = useState<string>("");
	const [inputSolution, setInputSolution] = useState<string>("");
	const [items, setItems] = useState<Array<string>>([itemImage, itemImage]);
	const [theme, setTheme] = useState<string>(themeImage);
	const [divWidth, setDivWidth] = useState<number>(680);
	const getDivStatus = useCallback((node) => {
		if (node !== null) {
			setDivWidth(node.getBoundingClientRect().width);
		}
	}, []);

	const handleChangeName = (
		event: React.ChangeEvent<HTMLInputElement>
	): void => {
		setTextName(event.target.value);
	};

	const handleChangeSolution = (
		event: React.ChangeEvent<HTMLTextAreaElement>
	): void => {
		setTextSolution(event.target.value);
	};

	const handleSubmit = (): void => {
		setInputName(textName);
		setInputSolution(textSolution);
	};

	const chooseItem = (id: string) => {
		const newItem = getItemFile(id);
		const newItems = [...items, newItem];
		newItems.shift();
		setItems(newItems);
	};
	const chooseZetsubo = (id: string) => {
		const newZetsubo = getZetsuboFile(id);
		setTheme(newZetsubo);
	};

	return (
		<>
			<div className="py-2 px-4 font-xl font-sans bg-black text-white w-full">
				<p className="text-xs py-0 px-1 m-0 text-sky-400">
					<a
						href="https://twitter.com/search?f=top&q=(%23%E4%B8%BB%E5%BD%B9%E3%81%AF%E6%88%91%E3%80%85%E3%81%A0)&src=typed_query"
						target="_blank"
						rel="nofollow noreferrer"
						className="mr-2"
					>
						#主役は我々だ
					</a>
					<a
						href="https://twitter.com/search?q=(%23%E7%B5%B6%E6%9C%9B%E3%82%B9%E3%82%B1%E3%82%A4%E3%83%97)&src=typed_query"
						target="_blank"
						rel="nofollow noreferrer"
						className="mr-2"
					>
						#絶望スケイプ
					</a>
					<a href="https://twitter.com/search?f=top&q=(%23%E4%BF%BA%E3%81%8C%E5%8A%A9%E3%81%91%E3%81%9F)&src=typed_query">
						#俺が助けた
					</a>
				</p>
				<p className="mb-2 border-gray-500 border-b pb-3">
					【絶望スケイプ】ついにチーノを救出！絶望的状況から助け出したのは我々だ！【解決策共有編】
				</p>
				<Disclosure>
					{(obj: { open: boolean }) => (
						<>
							<Disclosure.Button className="flex items-center mb-2 w-full">
								<div className="mx-2 w-12">
									<img src="./assets/logo.png" alt="logo" className="w-full" />
								</div>
								<p>{obj.open ? "＞ 使い方を閉じる" : "＞ 使い方を開く"}</p>
							</Disclosure.Button>
							<Disclosure.Panel className="text-sm">
								<p className="mb-3">
									絶望スケイプで遊んだら、チーノを助け出した解決策をSNS上に共有しよう！
								</p>
								<ul>
									<li>
										1.
										はじめに、今回の絶望的状況を１つと、解決に使ったアイテムを２つ選んでくれ！
									</li>
									<li>
										2.
										次に、入力フォームに、今回の解決策・お名前を入力しよう。「プレイ」ボタンを押すと、画像に入力した文字が反映されるぞ。
									</li>
									<li>
										3.
										名前は何度でも修正・変更できるけど、日付・時刻は最新時点の情報が反映されるから気をつけよう。
									</li>
									<li>
										4.
										完成したら、画像を右クリック、長押しなどで保存して、Twitterの投稿に添付しよう！
									</li>
								</ul>
								<p className="py-1 text-red-500 font-bold">
									再配布を目的としたネットワークへのアップロード、目的外での利用はNGとなります。
								</p>
							</Disclosure.Panel>
						</>
					)}
				</Disclosure>
			</div>

			<div className="max-w-[680px] p-4">
				<p className="text-white text-sm pl-1">
					絶望的状況と使ったアイテムを２つ選択してください
				</p>
				<div className="flex w-full overflow-x-scroll overscroll-x-auto mb-2">
					{zetsuboNameList.map((item, i) => {
						return (
							<ZetsuboCard
								image={item}
								key={item + i}
								chooseTheme={chooseZetsubo}
							/>
						);
					})}
				</div>
				<div className="flex w-full overflow-x-scroll overscroll-x-auto mb-2">
					{itemNameList.map((item, i) => {
						return (
							<ItemCard image={item} key={item + i} chooseItem={chooseItem} />
						);
					})}
				</div>
				<div className="py-6 h-[400px] flex justify-end bg-god-pattern bg-opacity-10 bg-no-repeat bg-right">
					<div className="w-full sm:w-3/4 text-center">
						<TextInput
							type={TextInputs.INPUT}
							onChange={handleChangeName}
							currentValue={textName}
							title={"名前を入力ください"}
						/>
						<TextInput
							type={TextInputs.TEXTAREA}
							onChange={handleChangeSolution}
							currentValue={textSolution}
							title={`解決策を入力する（70字以内）`}
							rows={2}
						/>
						<button
							className="bg-[#30e018] drop-shadow text-white font-bold text-xl rounded-lg py-2 px-10 active:scale-105"
							onClick={handleSubmit}
						>
							プレイ
						</button>
						<p className="text-xs my-2">
							※「プレイ」ボタンを押すと、画像に文字が反映されます
						</p>
					</div>
				</div>
				<div className="w-full mx-2" ref={getDivStatus}>
					<Canvas
						bgImage={bgImage}
						inputName={inputName}
						inputSolution={inputSolution}
						items={items}
						theme={theme}
						w={divWidth}
					/>
				</div>
				<div className="px-2">
					<div className="px-4 py-4 my-4 bg-white text-sm rounded-md">
						<p>
							※Twitter投稿ボタンよりツイートする場合、
							<span className="font-bold">画像をDLの上、ご自身での添付</span>
							をお願いします。
						</p>
						<p>
							※iPhoneの場合、カメラロールではなく
							<span className="font-bold">ファイルアプリに保存されます</span>。
						</p>
						<p className="text-red-500 font-bold">
							※Twitterに投稿されたツイート内容は、「◯◯の主役は我々だ！」の商品などで使う可能性がございます。
							<br />
							ツイート内容を使わないで欲しい場合は、ツイート内に「商品使用不可」を明記いただくか、該当ツイートを5月20日までに削除ください。
						</p>
					</div>
					<a
						className="py-3 px-4 bg-[#30e018] drop-shadow font-bold text-white text-xl rounded-lg sactive:scale-105"
						href="https://twitter.com/intent/tweet?hashtags=絶望スケイプ,俺が助けた&url=https://zetsubo-scape-460e8.web.app/"
						target="_blank"
						rel="nofollow noreferrer"
					>
						解決策をTwitterでシェアする
					</a>
				</div>
			</div>
		</>
	);
}
export default App;
